<form [formGroup]="blacklistForm">
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="countryCode" class="control-label required">{{'i18n.domain.administration.tariff-details.blacklist-tab.fields.countryCode' |
        translate}}</label>
      <ejs-dropdownlist [dataSource]="countryList" [fields]="enumDropdownSettings" [showClearButton]="true"
        [allowFiltering]="true" id="countryCode" formControlName="countryCode">
      </ejs-dropdownlist>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="controlPlateType" class="control-label">{{'i18n.domain.administration.tariff-details.blacklist-tab.fields.controlPlateType' |
        translate}}</label>
      <app-enum-drop-down-list formControlName="controlPlateType" id="controlPlateType" width="100%"
        [enumType]="ControlPlateType" [showClearButton]="false"
        baseTranslationString="i18n.shared.controlPlateType."></app-enum-drop-down-list>

    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="controlPlateNumber"
        class="control-label required">{{'i18n.domain.administration.tariff-details.blacklist-tab.fields.controlPlateNumber' | translate}}</label>
      <input id="controlPlateNumber" type="text" class="form-control" formControlName="controlPlateNumber" />
      <app-error-messages [control]="blacklistForm.controls.controlPlateNumber"></app-error-messages>
    </div>
  </div>
</form>